import * as Sentry from '@sentry/react';
import { getEnvByDomain } from './lib/get-env-by-domain';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://43e772f59bea9a70ffc7b41c4c2ad203@o4509316676845568.ingest.us.sentry.io/4509316678680576',
    sendDefaultPii: true,
    environment: getEnvByDomain(),
  });
}
